import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../lib/auth";

const STATUS_LABEL = {
    pending_payment: { label: "In afwachting", color: "bg-amber-100 text-amber-900 border-amber-300" },
    paid: { label: "Betaald", color: "bg-emerald-100 text-emerald-900 border-emerald-300" },
    printing: { label: "In productie", color: "bg-blue-100 text-blue-900 border-blue-300" },
    shipped: { label: "Verstuurd", color: "bg-zinc-900 text-white border-zinc-900" },
    cancelled: { label: "Geannuleerd", color: "bg-rose-100 text-rose-900 border-rose-300 line-through" },
};

export default function MyOrdersPage() {
    const { user } = useAuth();
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!user) return;
        api.get("/orders").then(({ data }) => setOrders(data)).finally(() => setLoading(false));
    }, [user]);

    if (!user) {
        return (
            <div className="min-h-[60vh] grid place-items-center p-10 text-center">
                <div>
                    <p className="label-tiny">Mijn bestellingen</p>
                    <h1 className="font-display text-4xl mt-2">Log in om je bestellingen te zien.</h1>
                    <Link to="/login" className="btn-primary mt-6 inline-block" data-testid="my-orders-login">Inloggen</Link>
                </div>
            </div>
        );
    }

    return (
        <div data-testid="my-orders-page" className="bg-zinc-50 min-h-screen">
            <div className="max-w-[1200px] mx-auto px-6 lg:px-10 py-12">
                <p className="label-tiny">Mijn bestellingen</p>
                <h1 className="font-display text-5xl mt-2">Overzicht & status</h1>

                {loading ? (
                    <p className="text-zinc-500 mt-10">Laden…</p>
                ) : orders.length === 0 ? (
                    <div className="mt-10 border border-zinc-200 bg-white p-12 text-center">
                        <p className="text-zinc-500">Je hebt nog geen bestellingen.</p>
                        <Link to="/designer" className="btn-primary mt-6 inline-block">Start je eerste ontwerp</Link>
                    </div>
                ) : (
                    <div className="mt-8 space-y-4">
                        {orders.map(o => {
                            const st = STATUS_LABEL[o.status] || { label: o.status, color: "bg-zinc-100 text-zinc-700 border-zinc-300" };
                            return (
                                <div data-testid={`my-order-${o.order_number}`} key={o.id} className="border border-zinc-200 bg-white p-5 flex flex-wrap gap-4 items-center justify-between">
                                    <div className="flex-1 min-w-[200px]">
                                        <p className="font-mono-dm text-xs text-zinc-500">{o.order_number}</p>
                                        <p className="font-semibold mt-1">{o.items.length} item{o.items.length !== 1 ? "s" : ""}</p>
                                        <p className="text-xs text-zinc-500 mt-1">{new Date(o.created_at).toLocaleDateString("nl-BE", { day: "2-digit", month: "short", year: "numeric" })}</p>
                                    </div>
                                    <div className="text-right">
                                        <p className="font-display text-2xl">€ {o.total.toFixed(2)}</p>
                                        <p className="text-xs text-zinc-500">{o.payment_method}</p>
                                    </div>
                                    <div>
                                        <span data-testid={`my-order-status-${o.order_number}`} className={`inline-block px-3 py-1.5 text-xs font-bold uppercase tracking-wider border ${st.color}`}>
                                            {st.label}
                                        </span>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
}
